<div class="nova__dialog__toolbar">
    <div class="nova__dialog__toolbar__title">
        {{dialogTitle}}
    </div>
</div>
<div mat-dialog-content class="nova__dialog__content">
    <div>
        {{dialogBody}}
    </div>

    <mat-dialog-actions class="nova__dialog__content__actions">
        <button data-qa-id="DelegationSetInactiveConfirmButton" mat-flat-button color="primary" (click)="setDelegationToInactive()">
            {{dialogConfirm}}
        </button>
        <button data-qa-id="DelegationSetInactiveConfirmButton" mat-flat-button color="cancel" [mat-dialog-close]="false">
            Cancel
        </button>
    </mat-dialog-actions>
</div>
